import "./design-components.css";

export function BigButton({ children, onClick, variant = "primary", disabled, className = "", ...rest }) {
  return (
    <button
      className={`wmleye-bigbtn wmleye-bigbtn--${variant} ${className}`}
      onClick={onClick}
      disabled={disabled}
      {...rest}
    >
      {children}
    </button>
  );
}

export function Card({ children, className = "", ...rest }) {
  return (
    <div className={`wmleye-card ${className}`} {...rest}>
      {children}
    </div>
  );
}
